import { BlendMode, DrawableRectangle, IParamHandle, Layout, param, Sprite, Stretch, view } from "@spawn/core";
import { LoadingScene } from "@spawn/slot-machine";
import Color from "color";
import { NrgBackgroundView } from "./backgroundView";

@view
export class DarkLoadingScene extends LoadingScene {
	// A string: a Color param loses its type.
	@param({ default: "#331100" }) dimColor!: IParamHandle<string>;
	/** 0 turns the dimming off. */
	@param({ default: 0.2 }) dimAlpha!: IParamHandle<number>;

	protected override createDimming(): void {
		this.dimmingLayer = new DrawableRectangle({
			fillColor: new Color(this.dimColor()),
			fillAlpha: this.dimAlpha(),
			layout: new Layout(Stretch.Horizontal, Stretch.Vertical),
		});

		this.dimmingLayer.blendMode = BlendMode.Multiply;
	}

	protected override createBackground(): void {
		this.backgroundView = new Sprite(this.landscapeBackground(), this.getBackgroundLayout());
		const bgView = new NrgBackgroundView();
		this.backgroundView.addChild(bgView);
	}
}
